import React, { forwardRef, InputHTMLAttributes } from 'react'
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker'
import tw from 'twin.macro'
import { SlIcon } from '@shoelace-style/shoelace/dist/react'

import 'react-datepicker/dist/react-datepicker.css'

const StyledInput = tw.div`
  flex items-center gap-20 bg-dark-gray rounded-6 p-12
`

export interface DatePickerProps extends ReactDatePickerProps {
  inputProps?: InputHTMLAttributes<HTMLInputElement>
}

const DateTimePicker: React.FC<DatePickerProps> = ({ inputProps = {}, ...props }) => {
  const CustomInput = forwardRef(({ value, onClick, onChange }: any, ref: any) => (
    <StyledInput>
      <SlIcon name="clock" library="unicons" className="text-dark-gray-200" />
      <input className="w-full" value={value || ''} onClick={onClick} onChange={onChange} ref={ref} {...inputProps} />
    </StyledInput>
  ))
  return <ReactDatePicker customInput={<CustomInput />} portalId="reactDatePicker" {...props} />
}

export default DateTimePicker
